import { watch, type Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useIntegrator, type IntegratorWallets } from '@nsftx/seven-client-retail-vue-integrator'
import { logService } from '@nsftx/seven-client-retail-utils'
import { getCurrencySymbol } from '@nsftx/seven-nxg-retail-vue-sdk'
import { useWalletStore } from '@/stores/wallet/walletStore'

const LOG_PREFIX = '[integratorSSBTSettingsService]'

const init = () => {
  const { activeWallet } = storeToRefs(useWalletStore())

  watchActiveWalletCurrency(activeWallet)
}

const updateCurrencySettings = (currency: string) => {
  const activeCurrency = {
    code: currency,
    symbol: getCurrencySymbol(currency)
  }

  const { updateSettings } = useIntegrator()
  updateSettings({ activeCurrency })
  logService.debug(`${LOG_PREFIX} Settings successfully updated.`, {
    code: 'ST_INTEGRATOR_SETTINGS_UPDATE_SUCCESS',
    details: {
      currency: activeCurrency
    }
  })
}

const watchActiveWalletCurrency = (activeWallet: Ref<IntegratorWallets[number] | null>) => {
  watch(activeWallet, (wallet) => {
    if (!wallet?.currency) {
      return
    }

    updateCurrencySettings(wallet.currency)
  })
}

export default { init }
